import { render, staticRenderFns } from "./BtnIconEdit.vue?vue&type=template&id=6764eea8&scoped=true&"
import script from "./BtnIconEdit.vue?vue&type=script&lang=js&"
export * from "./BtnIconEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6764eea8",
  null
  
)

export default component.exports